module.exports = __webpack_public_path__ + "img/logo.537d5c2d.png";